export const KEY_SELECTED_CATEGORY = "categorySel";